import type { ErrorCopy } from '@shared/errors/catalog';

/**
 * The `error_code` values the two credited-person surfaces meet, in
 * `backend-content`'s namespace.
 *
 * **Never inline a backend code in JSX.** The code is a log key; what reaches
 * the operator is the sentence, and the `X-Request-ID` is what they quote.
 *
 * `CONTENT_CONFLICT` is the sharpest of these. A person cannot hold the same
 * role twice on one title — the service refuses the duplicate on a unique
 * constraint rather than inserting a second identical row — so the copy names
 * what already exists instead of reading as a generic state clash.
 */
export const peopleErrors: Readonly<Record<string, ErrorCopy>> = {
  CONTENT_CREDIT_PROFILE_NOT_FOUND: {
    message: 'لم نعثر على هذا المنسوب. قد يكون حُذف من السجلّ.',
    tone: 'warning',
  },
  CONTENT_NOT_FOUND: {
    message: 'لم نعثر على العنصر المطلوب. أعد تحميل الصفحة.',
    tone: 'warning',
  },
  CONTENT_CONFLICT: {
    message: 'هذه النسبة مسجّلة على العنوان نفسه بالدور نفسه. اختر دوراً آخر أو عنواناً آخر.',
    tone: 'warning',
  },
  CONTENT_CREDIT_ROLE_NOT_CONFIGURED: {
    message: 'هذا الدور غير مفعّل. اختر دوراً من القائمة.',
    tone: 'warning',
  },
  CONTENT_BAD_INPUT: {
    message: 'راجع الحقول ثمّ أعد الإرسال.',
    tone: 'warning',
  },
  CONTENT_FORBIDDEN: {
    message: 'هذا الإجراء خارج صلاحيّتك.',
    tone: 'warning',
  },
  CONTENT_RATE_LIMITED: {
    message: 'طلبات كثيرة في وقت قصير. انتظر قليلاً ثمّ أعد المحاولة.',
    tone: 'warning',
  },
};
